import { createSlice } from '@reduxjs/toolkit'
import { generateGalleryName } from '../../Helpers/GalleryHelper'

export interface Gallery {
  id: number
  name: string
  autovalidate?: boolean
  channel?: string
  imageOnGalleryPriority?: number
  virtualId?: number
  autofocus?: boolean
}

export const galleriesSlice = createSlice({
  name: 'galleries',
  initialState: {
    galleries: [] as Gallery[],
    isEdited: false,
  },
  reducers: {
    setGalleries: (state, action) => {
      state.galleries = action.payload
    },
    resetGalleryChanges: state => {
      state.isEdited = false
    },
    addGallery: (state, action) => {
      state.galleries.push({
        id: action.payload,
        name: generateGalleryName(action.payload),
        virtualId: action.payload,
        autofocus: true,
      })

      state.isEdited = true
    },
    replaceGallery: (state, action) => {
      const galleryIndex = state.galleries.findIndex(gallery => gallery.name === action.payload.name)
      if (galleryIndex !== -1) {
        state.galleries = state.galleries.map(gallery => {
          if (gallery.name === action.payload.name) {
            return action.payload
          }

          return gallery
        })
      }
    },
    updateGalleryName: (state, action) => {
      const gallery = state.galleries.find(gallery => gallery.id === action.payload.id)

      if (gallery) {
        gallery.name = action.payload.name
        state.isEdited = true
      }
    },
    removeGallery: (state, action) => {
      const galleryIndex = state.galleries.findIndex(gallery => gallery.id === action.payload)
      if (galleryIndex !== -1) {
        state.galleries = state.galleries.filter(gallery => gallery.id !== action.payload)
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { setGalleries, addGallery, replaceGallery, updateGalleryName, removeGallery, resetGalleryChanges } =
  galleriesSlice.actions

export default galleriesSlice.reducer
